    import { Box,Button,Flex,Select,InputGroup,
      InputLeftElement,Input, Text, 
      TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem, Checkbox, 
      Spinner,
      Textarea,InputRightElement,useToast,
      Stack} from "@chakra-ui/react";
    import { TopDisplay } from "../../../../components";
    import { IoMdAdd as AddIcon } from "react-icons/io";
    import { LuSearch as SearchIcon } from "react-icons/lu";
    import { useState, useEffect } from "react";
    import { useMutation, useQuery, useQueryClient } from 'react-query';
    import styled from "@emotion/styled";
    import { atom, useAtom } from 'jotai';
    import apiCall from '../../../../utils/apiCall';
    import {TopLink} from '../';
    import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
    import { Formik,Form,Field } from "formik";
    import {TablePopUp} from '../../../../components';
    import * as Yup from 'yup';
    import { format } from "date-fns";
    import { Loader } from "../../../../customs";
    import ReactPaginate from "react-paginate";
    import { TbReload as ReloadIcon } from "react-icons/tb";
    import { AxiosError } from "axios";



    const HeadStyle={
      borderBottom:"1px solid var(--dark-green-color)",
      padding:'15px 5px',
    }
    const DataStyle = {
      padding:'5px 5px',
    }


    const ROWSTYLE = styled.tr`
      & > td:last-of-type > *{
        display:none;
      }
      :hover > td{
        background-color:var(--table-highlight);
        &:last-of-type > *{
          display:block;
        }
      } 
      &.active > td:last-of-type > *{
        display:block !important;
      }  
    `

    const WitholdExamAtom = atom<number | null>(null);


    export default function WitholdExam() {
      const [hide,set_hide] = useState<boolean>(true);
      const [,set_modal] = useAtom(modalAtom);
      const [,set_open] = useAtom(openAtom);
      const [active] = useAtom<number | string | null>(WitholdExamAtom);
      const [,set_period] = useState('');

      const {data:allExamPeriod} = useQuery(['exam-period'],{
        queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
        select(data){
          return data.data.Data;
        },
      })
      const {data:allExamSubject} = useQuery(['exam-subject'],{
        queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
        select(data){
          return data.data.Data;
        },
      })

      const {data:allLevel} = useQuery(['exemption'],{
          queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
          select(data){
            return data.data.Data;
          },
        })


      const {isLoading,data:allWitholdExam} = useQuery(['exam-reschedule'],{
        queryFn:async ()=> await apiCall().get(`/Exam/withheld-exams`),
        select(data){
          return data.data.Data;
        }
      })
      const [search,set_search] = useState('');

      const [filter_data, set_filter_data] = useState<any[]>(allWitholdExam);
      
      const handleSearch = (e: any) => {
        let val = e.target.value;
        set_search(val);
      
        if (val) {
          let new_data = allWitholdExam?.filter((eData: any) =>
            eData.StudentMembershipNo && eData.StudentMembershipNo.toLowerCase().includes(val.toLowerCase())
          );
      
          if (new_data.length > 0) {
            set_filter_data(new_data);
          } else {
            set_filter_data([]); // Set to empty array to indicate "Not found"
          }
        } else {
          set_filter_data(allWitholdExam); // Reset to full data if search is cleared
        }
      };
      
      
      const itemsPerPage = 10;
      const [itemOffset, setItemOffset] = useState(0);
      const endOffset = itemOffset + itemsPerPage;
      console.log(`Loading items from ${itemOffset} to ${endOffset}`);
      const currentItems = filter_data?.slice(itemOffset, endOffset);
      const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
      const handlePageClick = (event:any) => {
        const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
        console.log(
          `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
      };
      useEffect(()=>{
        set_filter_data(allWitholdExam)
      },[allWitholdExam])

      const handleAddwitheoldExam = () =>{
        set_modal({
          header:'Withhold Exam',
          content:<AddType />
        })
        set_open(true);
    }

      return (
        <> 
        {isLoading?<Loader />:
        <Box>
          <TopLink />
          <TopDisplay label="Withold Exam/Unwithold in options" button_array={[
              <Button onClick={handleAddwitheoldExam} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Withold Exams</Button>
            ]} />
            <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
                <InputLeftElement pointerEvents='none'>
                  <SearchIcon color='gray.300' />
                </InputLeftElement>
                <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
                <span style={{position:'absolute',zIndex:'1',
                right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
              </InputGroup>
              {/* <Select placeholder="Active diet" width="150px" bg="var(--white-color)" borderColor="var(dark-green-color)" onChange={(e:any)=>set_period(e.target.value)}>
                {allExamPeriod && allExamPeriod?.length > 0 ?allExamPeriod?.map((ePeriod:any)=>
                <option key={ePeriod?.Id} value={ePeriod?.Id}>{ePeriod?.ExamName}</option>
              ):''}
              </Select> */}
              

            </Flex>
            <Flex mt="25px" flexDir="column" gap="10px">
            <Text m="0" fontSize="1rem">All Witheld  Exams</Text>
              <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
            </Flex>
        {filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
              <Table size='sm'>
                <Thead>
                  <Tr >
                    <Th sx={HeadStyle}>Student No</Th>
                    <Th sx={HeadStyle}>Exam Diet</Th>
                    <Th sx={HeadStyle}>Level</Th>
                    <Th sx={HeadStyle}>Subjects</Th>
                    <Th sx={HeadStyle}>Score</Th>
                    <Th sx={HeadStyle}>Grade</Th>
                    <Th sx={HeadStyle}>Date Witheld</Th>
                    <Th sx={HeadStyle}>Reason</Th>
                    <Th sx={HeadStyle}>IsLifted</Th>
                    <Th sx={HeadStyle}>DateLifted</Th>
                    <Th sx={HeadStyle}>Lifted Reason</Th>
                    <Th sx={HeadStyle}>Final-Score</Th>
                    <Th sx={HeadStyle}>Final-Grade</Th>
                    <Th sx={HeadStyle}>CurrentStatus</Th>


                    <Th sx={HeadStyle} w="50px"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                      {currentItems.map((eWitholdExam: any) => (
                          <ROWSTYLE
                          key={eWitholdExam.StudentMembershipNo}
                          className={eWitholdExam.StudentMembershipNo === active ? 'active' : ''}
                          >
                          <Td sx={DataStyle}>{eWitholdExam.StudentNo}</Td>
                          <Td sx={DataStyle}>
                              {allExamPeriod &&
                              allExamPeriod.find((ePeriod: any) => ePeriod.Id === eWitholdExam.ExamPeriodId)?.ExamName || 'N/A'}
                          </Td>
                          <Td sx={DataStyle}>{eWitholdExam.Subject?.Level?.ExemptionName || 'N/A'}</Td>
                          <Td sx={DataStyle}>{eWitholdExam.Subject?.Name || 'N/A'}</Td>
                          <Td sx={DataStyle}>{eWitholdExam.OriginalGradeScore}</Td>
                          <Td sx={DataStyle}>{eWitholdExam.OriginalGrade}</Td>
                          <Td sx={DataStyle}>{format(new Date(eWitholdExam.DateWithheld), "dd/MM/yyyy")}</Td>
                          <Td sx={DataStyle}>{eWitholdExam.Reason}</Td>
                          <Td sx={DataStyle}>{eWitholdExam.IsLifted ? 'YES' : 'NO'}</Td>
                          <Td sx={DataStyle}>
                              {eWitholdExam.DateLifted ? format(new Date(eWitholdExam.DateLifted), "dd/MM/yyyy") : 'N/A'}
                          </Td>
                          <Td sx={DataStyle}>{eWitholdExam.LiftedReason || 'N/A'}</Td>
                          <Td sx={DataStyle}>{eWitholdExam.CurrentGradeScore}</Td>
                          <Td sx={DataStyle}>{eWitholdExam.CurrentGrade}</Td>
                          <Td sx={DataStyle}>{eWitholdExam.CurrentStatus}</Td>
                          <Td sx={DataStyle} w="50px" h="50px">
                          <TempPopUp index={eWitholdExam.StudentMembershipNo} data={eWitholdExam} />
                          </Td>
                          </ROWSTYLE>
                      ))}
                      </Tbody>

              </Table>
            </TableContainer>
            :'No Witheld Exams'  
          }
          <StylePaginateBox>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
            />

          </StylePaginateBox>

        </Box>
    }
        </>
      
      )
    }
    const StylePaginateBox = styled.div`
      width:100%;
      & > ul{
        list-style-type: none;
        text-align:center;
        padding:0;
        margin:0;
        margin-top:10px;
      } 
      & > ul > li{
        display: inline;
        margin:0 5px;
        padding:2px 5px;
        border-radius: 3px;
        background-color: transparent;
        color:var(--dark-green-color);
      }
      & > ul > li.selected{
        background-color: var(--highlight-paginate-background);
        color:var(--highlight-paginate-color);
      }
      & > ul > li:first-of-type,
      & > ul > li:last-of-type{
        font-weight: bold;
      }
    `

    const Label = styled.label``; 

    const AddSchema = Yup.object({
      StudentNo: Yup.string().required('Student number is required'),
      ActiveDiet: Yup.number().required('Active Diet is required'),
      Reason: Yup.string(),
    });

    const AddType = (props: any) => { 
      const queryClient = useQueryClient();
      const [, set_open] = useAtom(openAtom);
      const [, set_Nopen] = useAtom(openNAtom);
      const [, set_notification] = useAtom(notificationAtom);
      const [studentNo, setStudentNo] = useState<string>('');
      const [errorMessage, setErrorMessage] = useState('');
      const [tempStudentNo, setTempStudentNo] = useState(''); // Hold temporary input value
      const [selectedSubjects, setSelectedSubjects] = useState<string[]>([]);

      const { data: allExamPeriod } = useQuery(['exam-period'], {
        queryFn: async () => await apiCall().get(`exam/setup/examPeriod`),
        select(data) {
          return data.data.Data;
        },
      });

      const {data:allExamSubject} = useQuery(['exam-subject'],{
        queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
        select(data){
          return data.data.Data;
        },
      })

      interface ApiErrorResponse {
        Message: string;
      }

      const { data: studentData, refetch: fetchStudentData, isFetching: isFetchingStudent, error } = useQuery(
        ['fetchStudentData', studentNo],
        async () => {
          const response = await apiCall().get('/Exam/examWithhold', {
            params: { studentNo },
          });
          //console.log("Student Data:", response.data); // Add this line to inspect the response structure
          return response.data;
        },
        {
          enabled: false, // Only fetch when triggered
          onError: (err: any) => {
            setErrorMessage(
              err?.response?.data?.Message || 'Error fetching data. Please check the student number.'
            );
          },
          onSuccess: (data) => {
            if (!data || !data.Level) {
              setErrorMessage('No student found.');
            } else {
              setErrorMessage('');
            }
          },
        }
      );

      const { isLoading, mutate: addUpdate } = useMutation(
        async (data: any) => await apiCall().post(`/Exam/examWithhold`, data),
        {
          onSuccess: (data) => {
            set_notification({
              type: 'success',
              message: data?.data?.Message || 'Exam Witheld Successfully',
            });
            set_Nopen(true);
            queryClient.invalidateQueries(['exam-reschedule']);
          },
          onError: (error: any) => {
            set_notification({
              type: 'error',
              message: error?.response?.data?.Message || 'Error Occurred',
            });
            set_Nopen(true);
          },
          onSettled: () => {
            set_open(false);
          },
        }
      );

      const handleFetchClick = () => {
        if (tempStudentNo) {
          setStudentNo(tempStudentNo); // Update `studentNo` with latest input
          fetchStudentData(); // Trigger the fetch
        } else {
          setErrorMessage('Please enter a valid student number.');
        }
      };

      const handleStudentNoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTempStudentNo(e.target.value);
      };

      const handleSubjectSelection = (e: React.ChangeEvent<HTMLInputElement>, subjectId: string) => {
        const { checked } = e.target;
        setSelectedSubjects((prevSelectedSubjects) => {
          if (checked) {
            return [...prevSelectedSubjects, subjectId];
          } else {
            return prevSelectedSubjects.filter(id => id !== subjectId);
          }
        });
      };
      

      return (
        <Formik
        initialValues={{
          StudentNo: '',
          ActiveDiet: '',
          Reason: '',
        }}
        validationSchema={AddSchema}
        onSubmit={(values: any) => {
          const data = {
            StudentNo: values.StudentNo,
            ExamPeriodId: values.ActiveDiet, 
            ExamSubjectIds: selectedSubjects,
            Reason: values.Reason,
          };
          addUpdate(data);
        }}
      >
        {(formik) => {
          const { values, setFieldValue } = formik;
      
          return (
            <Form>
              <Flex flexDir="column" align="center" gap="20px">
                {/* Student Number Input with Fetch Button */}
                <InputGroup>
                  <Field
                    as={Input}
                    bg="var(--white-color)"
                    borderColor="var(--dark-green-color)"
                    color="var(--dark-green-color)"
                    placeholder="Student / Member ID"
                    name="StudentNo"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setFieldValue("StudentNo", e.target.value);
                      handleStudentNoChange(e);
                    }}
                  />
                  <InputRightElement width="4.5rem">
                    <Button h="1.75rem" size="sm" bg="var(--highlight-green)"
                  color="var(--white-color)" onClick={handleFetchClick}>
                      Check
                    </Button>
                  </InputRightElement>
                </InputGroup>
      
                {isFetchingStudent && <Spinner />}
                {!isFetchingStudent && errorMessage && !studentData?.Data && (
                  <Text color="red.500">{errorMessage}</Text>
                )}

            {studentData?.Data && (
            <Box 
              mt={4} 
              p={3} 
              bg="gray.100" 
              borderRadius="md" 
              w="100%" 
              border="2px solid" 
              borderColor="green.500"
            >
              {/* Display Level and ExamPeriod */}
              <Text fontWeight="bold" mb={1}>
                Level: <span style={{ fontWeight: 'normal' }}>{studentData.Data.Level || 'No level data available'}</span>
              </Text>
              <Text fontWeight="bold" mb={1}>
                Exam Period: <span style={{ fontWeight: 'normal' }}>{studentData.Data.ExamPeriod || 'No exam period data available'}</span>
              </Text>
              
              <Text fontWeight="bold" mb={1}>Subjects:</Text>
              <Stack spacing={2} pl={4}>
                {Array.isArray(studentData.Data.Subjects) && studentData.Data.Subjects.length > 0 ? (
                  studentData.Data.Subjects.map((subject: any) => (
                    <Checkbox
                      key={subject.ExamSubject.Id}
                      value={subject.ExamSubjectId}
                      isChecked={selectedSubjects.includes(subject.ExamSubjectId)}
                      onChange={(e) => handleSubjectSelection(e, subject.ExamSubjectId)}
                      borderColor="green.500" 
                      iconColor="green.500" 
                      colorScheme="green" 
                    >
                      {subject.ExamSubject.Name || 'Unnamed Subject'}
                    </Checkbox>
                  ))
                ) : (
                  <Text>No subjects found for this student.</Text>
                )}
              </Stack>
            </Box>
          )}



                {/* Active Diet Dropdown */}
                <Field as={Select} name="ActiveDiet" placeholder="Exam Diet">
                  {Array.isArray(allExamPeriod) && allExamPeriod.length > 0 ? (
                    allExamPeriod.map((eType: any) => (
                      <option key={eType.Id} value={eType.Id}>
                        {eType.ExamName}
                      </option>
                    ))
                  ) : (
                    <option value="">No data available</option>
                  )}
                </Field>
      
                <Box fontWeight="500">Reasons</Box>
                <Textarea
                  placeholder="Reason"
                  resize="vertical"
                  size="sm"
                  onChange={(e) => setFieldValue("Reason", e.target.value)}
                />
      
                <Button
                  disabled={isLoading}
                  type="submit"
                  bg="var(--dark-green-color)"
                  color="var(--white-color)"
                >
                  {isLoading ? 'Loading' : 'Submit'}
                </Button>
              </Flex>
            </Form>
          );
        }}
      </Formik>
      
      )
    }

    const TempPopUp = (props: any) => {
      const { index, data } = props;
      const [active, set_active] = useAtom(WitholdExamAtom);
      const [, set_open] = useAtom(openAtom);
      const [, set_modal] = useAtom(modalAtom);
      const [, set_Nopen] = useAtom(openNAtom);
      const [, set_notification] = useAtom(notificationAtom);
      const queryClient = useQueryClient();

      // Fetch exam subjects and periods
      const { data: setupData } = useQuery('exam-setup-data', async () => {
        const [examSubjects, examPeriods] = await Promise.all([
          apiCall().get('exam/setup/examSubject'),
          apiCall().get('exam/setup/examPeriod'),
        ]);
        return {
          allExamSubject: examSubjects.data.Data,
          allExamPeriod: examPeriods.data.Data,
        };
      });

      const handleClick = () => {
        if (index === active) {
          set_active(null);
        } else {
          set_active(index);
        }
      };
      const handleView = () => {
        set_modal({
          header: 'View Withheld Exams',
          content: (
            <Grid templateColumns="200px 1fr" gap={4} p="10px">
              {/* Student Information */}
              <GridItem>
                <Text fontWeight="bold">Student No:</Text>
              </GridItem>
              <GridItem>
                <Text>{data?.StudentNo || 'N/A'}</Text>
              </GridItem>

              <GridItem>
                <Text fontWeight="bold">Exam Diet:</Text>
              </GridItem>
              <GridItem>
                <Text>
                  {setupData?.allExamPeriod?.find((e: any) => e.Id === data?.ExamPeriodId)?.ExamName || 'N/A'}
                </Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Exam Level:</Text>
              </GridItem>
              <GridItem>
                <Text>{data.Subject?.Level?.ExemptionName || 'N/A'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Exam Subjects:</Text>
              </GridItem>
              <GridItem>
                <Text>{data.Subject?.Name || 'N/A'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Original Score:</Text>
              </GridItem>
              <GridItem>
                <Text>{data?.OriginalGradeScore || 'N/A'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Original Grade:</Text>
              </GridItem>
              <GridItem>
                <Text>{data?.OriginalGrade || 'N/A'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Date Witheld:</Text>
              </GridItem>
              <GridItem>
                <Text>{format(new Date(data.DateWithheld), "dd/MM/yyyy")}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Reason:</Text>
              </GridItem>
              <GridItem>
                <Text>{data?.Reason || 'N/A'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Is Lifted:</Text>
              </GridItem>
              <GridItem>
                <Text>{data.IsLifted ? 'YES' : 'NO'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Date Lifted:</Text>
              </GridItem>
              <GridItem>
                <Text>{data.DateLifted ? format(new Date(data.DateLifted), "dd/MM/yyyy") : 'N/A'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Lifted Reason:</Text>
              </GridItem>
              <GridItem>
                <Text>{data?.LiftedReason || 'N/A'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Current score:</Text>
              </GridItem>
              <GridItem>
                <Text>{data?.CurrentGradeScore || 'N/A'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Current Grade:</Text>
              </GridItem>
              <GridItem>
                <Text>{data?.CurrentGrade || 'N/A'}</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold">Current Status:</Text>
              </GridItem>
              <GridItem>
                <Text>{data?.CurrentStatus || 'N/A'}</Text>
              </GridItem>
            </Grid>
          ),
        });
        set_open(true);
        handleClick();
      };

      const handleUnwithheld = () => {
        set_modal({
            header: 'Unwithhold Exams',
            content: (
                <AddUnwithholdForm
                    initialData={{
                        StudentNo: data.StudentNo,
                        ExamPeriodId: data.ExamPeriodId,
                        ExamSubjectIds: data.ExamSubjectIds,
                        Reason: '',
                        FailStudent: false,
                    }}
                />
            ),
        });
        
    
        // Open modal
        set_open(true);
    };
    
    

      // Mutation to unwithhold exams
    //   const AddType = ({ initialData }: { initialData: any }) => {
    //       const { mutate: Unwithhold, isLoading } = useMutation<UnwithholdPayload, Error, UnwithholdPayload>({
    //         mutationFn: async (payload) => await apiCall().post('/Exam/examWithhold/unWithhold', payload),
    //         onSuccess: (data) => {
    //           set_notification({ message: 'Successfully updated the exam status', status: 'success' });
    //         },
    //       //   onError: (error: Error) => {
    //       //     set_notification({ message: error.message, status: 'error' });
    //       //   },
    //       // });
    //       onError(error:any){
    //           set_notification({
    //             type:'error',
    //             message:error.data.Message || 'Error Occured'
    //           })
    //           set_Nopen(true);
    //         },
    //         onSettled:()=>{
    //           set_open(false);
    //         }
    //       } )

    //   // Validation and error handling
    

    //   return (
    //     <TablePopUp
    //       click={handleClick}
    //       options={[
    //         { label: 'View Withheld Exams', click: handleView },
    //         { label: 'Unwithhold', click: handleUnwithheld },
    //       ]}
    //     />
    //   );
    // };
    type UnwithholdPayload = {
      StudentNo: string;
      ExamPeriodId: number;
      ExamSubjectIds: number[];
      Reason: string;
      FailStudent: boolean;
    };

    const AddUnwithholdForm = ({ initialData }: { initialData: any }) => {
      const toast = useToast(); 
    
      const { mutate: Unwithhold, isLoading } = useMutation(
        async (payload: UnwithholdPayload) =>
          await apiCall().post('/Exam/examWithhold/unWithhold', payload),
        {
          onSuccess: () => {
            toast({
              title: 'Success',
              description: 'Successfully unwithold the exam status.',
              status: 'success',
              duration: 5000,
              isClosable: true,
            });
            set_open(false); 
          },
          onError: (error: any) => {
            toast({
              title: 'Error',
              description: error.response?.data?.Message || 'An error occurred.',
              status: 'error',
              duration: 5000,
              isClosable: true,
            });
            set_Nopen(true); 
          },
          onSettled: () => {
            set_open(false); 
          },
        }
      );
    
      return (
          <Formik
              initialValues={{
                  StudentNo: initialData.StudentNo || '',
                  ExamPeriodId: initialData.ExamPeriodId?.toString() || '',
                  ExamSubjectIds: initialData.ExamSubjectIds?.map((id: number) => id.toString()) || [],
                  Reason: initialData.Reason || '',
                  FailStudent: initialData.FailStudent || false,
              }}
              validationSchema={Yup.object().shape({
                  StudentNo: Yup.string().required('Student number is required'),
                  ExamPeriodId: Yup.string().required('Exam period is required'),
                  ExamSubjectIds: Yup.array().min(1, 'At least one subject must be selected'),
                  Reason: Yup.string().required('Reason is required'),
              })}
              onSubmit={(values) => {
                  const payload: UnwithholdPayload = {
                      StudentNo: values.StudentNo,
                      ExamPeriodId: parseInt(values.ExamPeriodId, 10),
                      ExamSubjectIds: values.ExamSubjectIds.map((id: string) => parseInt(id, 10)),
                      Reason: values.Reason,
                      FailStudent: values.FailStudent,
                  };
                  Unwithhold(payload);
              }}
               >
              {({ values, setFieldValue }) => (
                  <Form>
                      <Field as={Input} name="StudentNo" borderColor="var(--dark-green-color)" label="Student Number" />
                      <Field as={Select} name="ExamPeriodId"  borderColor="var(--dark-green-color)" placeholder="Select Exam Period">
                          {setupData?.allExamPeriod?.map((period: { Id: number; ExamName: string }) => (
                              <option key={period.Id} value={period.Id}>
                                  {period.ExamName}
                              </option>
                          ))}
                      </Field>
                      <Box mt={4}>
                          <Text fontWeight="bold"  borderColor="var(--dark-green-color)" >Subjects:</Text>
              <Stack>
                  {setupData?.allExamSubject?.map((subject: { Id: number; Name: string }) => (
              <Checkbox
                  key={subject.Id}
                  value={subject.Id.toString()}
                  isChecked={values.ExamSubjectIds.includes(subject.Id.toString())}
                  onChange={(e) => {
                      const isChecked = e.target.checked;
                      const subjectId = e.target.value;
                      const newSubjects = isChecked
                          ? [...values.ExamSubjectIds, subjectId]
                          : values.ExamSubjectIds.filter((id: string) => id !== subjectId);
                      setFieldValue('ExamSubjectIds', newSubjects);
                  }}
              >
                  {subject.Name}
              </Checkbox>
                  ))}
              </Stack>
                </Box>
                <Box display="flex" flexDirection="column" alignItems="center" gap="12px" mt={4}>
                      <Field
                        as={Textarea}
                        name="Reason"
                        borderColor="var(--dark-green-color)"
                        placeholder="Reason for unwithholding"
                        width="100%"
                      />
                      <Checkbox
                        isChecked={values.FailStudent}
                        onChange={(e) => setFieldValue('FailStudent', e.target.checked)}
                        alignSelf="flex-start"
                      >
                        Mark as Fail
                      </Checkbox>
                      <Button
                        gap="6px"
                        type="submit"
                        isLoading={isLoading}
                        bg="var(--dark-green-color)"
                         color="var(--white-color)" 
                        disabled={isLoading}
                        alignSelf="center"
                      >
                        Submit
                      </Button>
                    </Box>

                  </Form>
              )}
          </Formik>
      );
  };
      return (
        <TablePopUp
          click={handleClick}
          options={[
            { label: 'View Withheld Exams', click: handleView },
            { label: 'Unwithhold Exams', click: handleUnwithheld },
          ]}
        />
      );
    }
    

